export const ContainerSx = {
  display: 'flex',
  width: '100%',
};
